<template>
  <div id="deliveryConfirm" v-if="isViewer">
    <dd-header
      :headerSubContentType=1
      :headerTelContentType=1
    />
    <div id="container">
      <dd-sitemap
        :pageKey="pageKey"
        :pageList="orderForm.pageList"
      />
      <div id="content">
        <div class="title">
          <h2>ご注文内容確認</h2>
        </div>
        <dd-item-confirm
          v-for="(itemData,index) in nowList"
          :key="'cart-item-confirm-' + index"
          :itemData="itemData"
          :index="index+Number(1)"
          @onShowEstimateModal="onShowEstimateModal"
        />
        <section id="totalPrice">
          <label class="bold">注文情報</label>
          <div class="input_list cart_price" style="background: #FFFFFF">
            <ul>
              <li>
                <table class="order_price_table">
                  <thead>
                    <tr>
                      <th>項目</th>
                      <th>単価</th>
                      <th>金額</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="b_separator">
                      <td>商品・配送料小計</td>
                      <td></td>
                      <td>{{formatPrice(cartData.orderPrice.itemSubTotalPrice)}}</td>
                    </tr>
                    <tr>
                      <td>消費税</td>
                      <td>10%</td>
                      <td>{{formatPrice(cartData.orderPrice.itemSubTotalTax)}}</td>
                    </tr>
                    <tr class="n_separator">
                      <td>商品・配送費合計</td>
                      <td></td>
                      <td>{{formatPrice(cartData.orderPrice.itemTotalPrice)}}</td>
                    </tr>
                  </tbody>
                </table>
                <table class="order_price_table" style="margin-top: 20px">
                  <tbody>
                    <template v-if="isConstruct">
                      <tr class="b_separator tbl_space">
                        <td>組立設置他サービス費小計</td>
                        <td></td>
                        <td>{{formatPrice(cartData.orderPrice.optSubTotalPrice)}}</td>
                      </tr>
                      <tr v-if="cartData.orderPrice.discntPrice">
                        <td>諸経費割引</td>
                        <td></td>
                        <td>(-{{formatPrice(cartData.orderPrice.discntPrice)}})</td>
                      </tr>
                      <tr class="n_separator" v-if="cartData.orderPrice.discntPrice">
                        <td>割引後小計</td>
                        <td></td>
                        <td>{{formatPrice(cartData.orderPrice.discntSubTotalPrice)}}</td>
                      </tr>
                      <tr :class="{n_separator: !cartData.orderPrice.discntPrice}">
                        <td>消費税</td>
                        <td>10%</td>
                        <td>{{formatPrice(cartData.orderPrice.optTotalTax)}}</td>
                      </tr>
                      <tr class="n_separator">
                        <td>組立設置他サービス費合計</td>
                        <td></td>
                        <td>{{formatPrice(cartData.orderPrice.optTotalPrice)}}</td>
                      </tr>
                    </template>
                    <tr class="b_separator">
                      <td>ご請求額合計</td>
                      <td></td>
                      <td>{{formatPrice(cartData.orderPrice.totalPrice)}}</td>
                    </tr>
                  </tbody>
                </table>
              </li>
            </ul>
          </div>
        </section>
        <section id="owner">
          <label class="text_size_big bold">発注者情報</label>
          <div class="input_list">
            <ul>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>発注者企業名：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{userData.corpName}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>郵便番号：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{userData.postcd}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>発注者住所：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{userData.state}} {{userData.city}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>以下、住所：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{userData.street}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>発注者氏名：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{userData.userLastName}} {{userData.userFirstName}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>（カナ）：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{userData.userLastNameKana}} {{userData.userFirstNameKana}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>電話番号：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{userData.tel}}</label>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <section id="delivery" v-if="!orderForm.isCarryIn">
          <label class="text_size_big bold">納品先情報</label>
          <div class="input_list">
            <ul>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>施主名(物件名)：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{deliveryData.businessName}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>納品先名：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{deliveryData.building}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>郵便番号：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{deliveryData.postcd}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>納品先住所：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{deliveryData.state}} {{deliveryData.city}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>以下、住所：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{deliveryData.street}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>受取人氏名：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{deliveryData.userLastName}} {{deliveryData.userFirstName}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>（カナ）：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{deliveryData.userLastNameKana}} {{deliveryData.userFirstNameKana}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>電話番号：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{deliveryData.tel}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>納品希望日： </label>
                </div>
                <div v-if="orderForm.isCarryIn">
                  <label class="text_size_middle bold"> ‐ </label>
                </div>
                <div v-else>
                  <label class="text_size_middle bold">{{getViewDate(deliveryData.deliveryDate)}} {{getViewTime()}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>配送時の連絡事項：</label>
                </div>
                <div class="word_wrap">
                  <label class="text_size_middle bold">{{deliveryData.message}}</label>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <section id="struct" v-if="orderForm.workFlag">
          <label class="text_size_big bold">組立設置情報</label>
          <div class="input_list">
            <ul>
              <li class="list_line2_center" v-if="structData.businessName">
                <div class="item_title_big">
                  <label>施主名(物件名)：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{structData.businessName}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>郵便番号：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{structData.postcd}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>設置先住所：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{structData.state}}{{structData.city}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>以下、住所：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{structData.street}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>立会人氏名：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{structData.userLastName}} {{structData.userFirstName}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>（カナ）：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{structData.userLastNameKana}} {{structData.userFirstNameKana}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>立会人電話番号：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{structData.tel}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>第一作業希望日：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{getViewDate(structData.desiredDate1st)}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>第二作業希望日：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{getViewDate(structData.desiredDate2nd)}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>第三作業希望日：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{getViewDate(structData.desiredDate3rd)}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>ご自宅のタイプ：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{homeType}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>駐車場の有無：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{parkingSpace}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>組立設置の連絡事項：</label>
                </div>
                <div>
                  <label class="text_size_middle bold word_wrap">{{this.structData.message}}</label>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <section v-if="!userData.isAccountPay">
          <label class="text_size_big bold">注意事項</label>
          <dd-payment-caution />
        </section>
        <section id="deli_confirm">
          <label class="text_size_big bold">確認事項</label>
          <div class="input_list">
            <div class="check_box">
              <input type="checkbox" id="confirmItem" v-model="confirmItem"/>
              <label for="confirmItem">商品仕様を確認しました。</label>
            </div>
            <div class="check_box">
              <input type="checkbox" id="confirmOrderCancel" v-model="confirmOrderCancel"/>
              <label for="confirmOrderCancel">オーダー家具のため、注文後のキャンセルはできません。</label>
            </div>
            <div class="check_box">
              <input type="checkbox" id="confirmUseRule" v-model="confirmUseRule"/>
              <label for="confirmUseRule">利用規約に同意して、購入する。</label>
            </div>
          </div>
        </section>
        <section id="form_button">
          <div id="regist_btn">
            <button type="submit" class="main_btn cancel_btn" @click="reEdit">戻る</button>
            <button type="submit" class="main_btn" v-bind:disabled="isOrderDisable" @click="payment()">{{payTypeLabel}}</button>
          </div>
        </section>
        <form name="ecform" :action="ecsiteUrl" method="post" accept-charset="Shift_JIS">
          <!-- <h4>EC接続テスト</h4> -->
          <div>
            <input type="hidden" name="in_kamei_id" v-bind:value="ecData.in_kamei_id">
            <input type="hidden" name="in_n" v-bind:value="ecData.in_n">
            <input type="hidden" name="in_redirecturl_ok" v-bind:value="ecData.in_redirecturl_ok">
            <input type="hidden" name="in_redirecturl_ng" v-bind:value="ecData.in_redirecturl_ng">
            <input type="hidden" name="in_redirecturl_can" v-bind:value="ecData.in_redirecturl_can">
            <input type="hidden" name="in_shori_kbn" v-bind:value="ecData.in_shori_kbn">
            <input type="hidden" name="in_moushikomi_kbn01" v-bind:value="ecData.in_moushikomi_kbn01">
            <input type="hidden" name="in_moushikomi_kbn02" v-bind:value="ecData.in_moushikomi_kbn02">
            <input type="hidden" name="in_kingaku" v-bind:value="ecData.in_kingaku">
            <input type="hidden" name="in_zei_kbn" v-bind:value="ecData.in_zei_kbn">
            <input type="hidden" name="in_mail_syu" v-bind:value="ecData.in_mail_syu">
            <input type="hidden" name="in_kyaku_mail" v-bind:value="ecData.in_kyaku_mail">
            <input type="hidden" name="in_keitai_sosin_flg" v-bind:value="ecData.in_keitai_sosin_flg">
            <input type="hidden" name="in_skigen_bango" v-bind:value="ecData.in_skigen_bango">
            <input type="hidden" name="in_kokyaku_id" v-bind:value="ecData.in_kokyaku_id">
            <input type="hidden" name="in_chumon_no" v-bind:value="ecData.in_chumon_no">
            <input type="hidden" name="in_tokushu1" v-bind:value="ecData.in_tokushu1">
            <input type="hidden" name="in_tokushu2" v-bind:value="ecData.in_tokushu2">
            <input type="hidden" name="in_shiharai_kbn" v-bind:value="ecData.in_shiharai_kbn">
            <input type="hidden" name="in_tskbn" v-bind:value="ecData.in_tskbn">
            <input type="hidden" name="in_keyaku_kbn" v-bind:value="ecData.in_keyaku_kbn">
          </div>
        </form>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import {mapActions, mapState} from 'vuex'
// import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as AppEc from '../utils/AppEc'
import * as Check from '../../utils/Check'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import {PAYMENT_STATUS} from '../../constants/Type'
import {HOME_TYPE} from '../constants/TypeEc'
import * as FormUtil from '../../utils/FormUtil'
// Module
import Header from '../components/common/DcHeader'
import SiteMap from '../components/common/SiteMap'
import ItemConfirm from '../components/order/ItemConfirm'
import PaymentCaution from '../components/order/PaymentCaution'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'OrderConfirm',
  components: {
    'dd-header': Header,
    'dd-sitemap': SiteMap,
    'dd-item-confirm': ItemConfirm,
    'dd-loading-modal': LoadingModal,
    'dd-payment-caution': PaymentCaution
  },
  data () {
    return {
      pageKey: 'orderConfirm',
      // 決済データ
      ecData: {},
      // 商品情報
      fileName: '',
      fillerName: '',
      constructDate: '',
      confirmItem: '',
      confirmOrderCancel: '',
      confirmUseRule: '',
      // TOP画面入力項目
      topForm: {},
      orderForm: {},
      userData: {},
      orderData: {},
      deliveryData: {},
      structData: {},
      errorMessage: { text: '' },
      validateErrorMessages: {},
      // 納品先ID
      submitDisable: false,
      ecsiteUrl: '',
      // 総額
      paymentFlag: false,
      isViewer: true
    }
  },
  computed: {
    ...mapState({
      cartData: state => state.cartData
    }),
    nowList: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return
      return this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
    },
    isOrderDisable: function () {
      if (this.confirmItem && this.confirmOrderCancel && this.confirmUseRule) {
        return false
      }
      return true
    },
    homeType: function () {
      return Object.keys(HOME_TYPE)
        .map(e => HOME_TYPE[e])
        .find(e => e.code === this.structData.homeType)
        .label
    },
    parkingSpace: function () {
      return FormUtil.getOnOff(this.structData.parkingSpace)
    },
    payTypeLabel: function () {
      if (this.userData.isAccountPay) {
        return '注文の確定'
      } else {
        return 'お支払い方法選択'
      }
    },
    businessName: function () {
      if (this.structData && this.structData.businessName) {
        return this.structData.businessName
      }
      return this.deliveryData.businessName
    },
    isConstruct: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return false
      return this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
        .some(c => c.opExFlag === true)
    }
  },
  methods: {
    ...mapActions({ getCartData: 'loadCartData' }),
    reEdit: function () {
      this.$router.go(-1)
    },
    payment: function () {
      if (this.paymentFlag) return
      this.paymentFlag = true
      this.$refs.loadingModalRef.showModal(true)
      let payload = {}
      let method = ''
      if (this.orderForm.workFlag) {
        payload = {
          businessId: this.deliveryData.businessId,
          businessName: this.businessName,
          postcd: this.deliveryData.postcd,
          state: this.deliveryData.state,
          city: this.deliveryData.city,
          street: this.deliveryData.street,
          building: this.deliveryData.building,
          userLastName: this.deliveryData.userLastName,
          userFirstName: this.deliveryData.userFirstName,
          userLastNameKana: this.deliveryData.userLastNameKana,
          userFirstNameKana: this.deliveryData.userFirstNameKana,
          tel: this.deliveryData.tel,
          delMessage: this.deliveryData.message,
          isRegistAddress: this.deliveryData.isRegistAddress,
          selectTime: this.deliveryData.selectTime,
          deliveryDate: this.getDeliveryDate(),
          structPostcd: this.structData.postcd,
          structState: this.structData.state,
          structCity: this.structData.city,
          structStreet: this.structData.street,
          structLastName: this.structData.userLastName,
          structFirstName: this.structData.userFirstName,
          structLastNameKana: this.structData.userLastNameKana,
          structFirstNameKana: this.structData.userFirstNameKana,
          structTel: this.structData.tel,
          structHomeType: this.structData.homeType,
          structParkingSpace: this.structData.parkingSpace,
          structMessage: this.structData.message,
          btPref1: this.structData.desiredDate1st,
          btPref2: this.structData.desiredDate2nd,
          btPref3: this.structData.desiredDate3rd
        }
        method = '/payment-struct'
      } else {
        payload = {
          businessId: this.deliveryData.businessId,
          businessName: this.businessName,
          postcd: this.deliveryData.postcd,
          state: this.deliveryData.state,
          city: this.deliveryData.city,
          street: this.deliveryData.street,
          building: this.deliveryData.building,
          userLastName: this.deliveryData.userLastName,
          userFirstName: this.deliveryData.userFirstName,
          userLastNameKana: this.deliveryData.userLastNameKana,
          userFirstNameKana: this.deliveryData.userFirstNameKana,
          tel: this.deliveryData.tel,
          delMessage: this.deliveryData.message,
          isRegistAddress: this.deliveryData.isRegistAddress,
          selectTime: this.deliveryData.selectTime,
          deliveryDate: this.deliveryData.deliveryDate
        }
        method = '/payment'
      }

      // 決済画面へ
      axios.post(DC_URL.ORDER + method, payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
            this.$refs.loadingModalRef.showModal(false)
          } else {
            if (this.userData.isAccountPay) {
              this.$router.push('/mmstyle/order/complete')
            } else {
              this.ecData = response.data.data
              this.ecsiteUrl = this.ecData.ecsiteUrl
              // 決済が返ってきたら、vuejsからformをsubmit
              this.$nextTick(function () {
                if (this.ecsiteUrl) {
                  // IEはformの文字コード指定でaccept-charsetが効かない事から独自対応をする
                  if (Check.isBrawserIE()) {
                    document.charset = 'SHIFT_JIS'
                  }
                  document.ecform.submit()
                } else {
                  this.$router.push('/mmstyle/error')
                }
              })
            }
          }
        // }).catch(error => {
        }).catch(error => {
          // this.validateErrorMessages = {}
          // Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          // this.$router.push('/mmstyle/error')
          App.showModal({
            messages: ['アクセスが集中しており、通信に失敗いたしました。恐れ入りますが、もう一度お試しください。'],
            messageType: 'error',
            onOk: () => {
            }
          })
          console.log(error)
          this.$refs.loadingModalRef.showModal(false)
        }).finally(() => {
          this.paymentFlag = false
        })
    },
    fetchData: function () {
      this.fileName = App.getLocalStorage(DC_STORAGE_KEY.FILE_NAME)
      this.topForm = App.getLocalStorage(DC_STORAGE_KEY.TOP_FORM)
      this.orderForm = App.getLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
      this.userData = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
      this.deliveryData = App.getLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
      this.structData = App.getLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
    },
    getViewDate: function (date) {
      return FormUtil.getViewDate(date)
    },
    getViewTime: function () {
      if (this.deliveryData.selectTime === 1) {
        return '午前中(8:00～12:00)'
      } else if (this.deliveryData.selectTime === 2) {
        return '午後(12:00～15:00)'
      } else if (this.deliveryData.selectTime === 3) {
        return '10:00～12:00'
      } else if (this.deliveryData.selectTime === 4) {
        return '12:00～14:00'
      } else if (this.deliveryData.selectTime === 5) {
        return '14:00～16:00'
      } else if (this.deliveryData.selectTime === 6) {
        return '16:00～18:00'
      } else if (this.deliveryData.selectTime === 7) {
        return '18:00～20:00'
      }
      return ''
    },
    onShowEstimateModal: function (estimateData) {
      this.$refs.loadingModalRef.showModal(true)
      // ダイアログ表示
      let modalData = {
        onOk: () => {
        },
        showSuccess: () => {
          this.$refs.loadingModalRef.showModal(false)
        },
        fileName: estimateData.fileName,
        titleDoor: estimateData.titleDoor,
        colorDoor: estimateData.colorDoor,
        titleCabine: estimateData.titleCabine,
        colorCabine: estimateData.colorCabine,
        titleCounter: estimateData.titleCounter,
        colorCounter: estimateData.colorCounter,
        priceData: estimateData.priceData,
        spaceJoincd: estimateData.spaceJoincd,
        dispOrderButton: false,
        dcProductCount: estimateData.dcProductCount,
        isCalcDelivery: true,
        isDrawing: estimateData.isDrawing,
        corpData: estimateData.corpData,
        isProductData: true
      }
      AppEc.showEstimateModal(modalData)
    },
    getDeliveryDate: function () {
      if (!this.orderForm.isCarryIn) {
        return this.deliveryData.deliveryDate
      }
      let deliDate = this.structData.desiredDate1st
      if (moment(deliDate).isAfter(this.structData.desiredDate2nd)) {
        deliDate = this.structData.desiredDate2nd
      }
      if (moment(deliDate).isAfter(this.structData.desiredDate3rd)) {
        deliDate = this.structData.desiredDate3rd
      }
      return moment(deliDate).add(-3, 'days').format('YYYY-MM-DD')
    },
    formatPrice: function (price) {
      return FormUtil.formatPrice(price)
    }
  },
  watch: {
  },
  mounted () {
    this.contentNo = 0
  },
  created () {
    this.fetchData()
    if (!this.orderForm || Object.keys(this.orderForm) <= 0) {
      let pageList = App.getLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
      if (Object.keys(pageList).length > 0) {
        this.$router.go(-pageList.length)
        this.isViewer = false
      } else {
        this.$router.push({
          name: 'DcError'
        })
      }
    }
    this.$store.dispatch('loadCartData', {reload: true})
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.order_price_table {
    th, td {
        background: #ffffff;
        border: none;
        padding: 0 5px;
        &:nth-child(1) {
            width: 40%;
        }
        &:nth-child(2) {
            width: 20%;
        }
        &:nth-child(3) {
            width: 40%;
            text-align: center;
        }
    }
    &.tbl_space {
        margin-top: 30px;
    }
    /* テーブル関連のセパレータ */
    .n_separator {
        border-top: 1px solid #000000;
    }
    .b_separator {
        border-top: 2px solid #000000;
    }
    .w_separator {
        border-top: 1px solid #000000;
    }
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/OrderConfirm.vue